import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AuthReducerContext from "./reducer/authReducer";
import AppRequestContext from "./api/AppRequestContext";

import "./i18n/config";
import "./index.css";
import "semantic-ui-css/semantic.min.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <AuthReducerContext>
        <AppRequestContext>
          <App />
        </AppRequestContext>
      </AuthReducerContext>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
